import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss']
})
export class BackToTopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('.back-to-top').fadeOut(0);
    $('.go-to-bottom').fadeOut(0);
  }

  @HostListener('window:scroll', ['$event']) onScrollEvent() {
    if ($(window).scrollTop() > 200) {
      $('.back-to-top').fadeIn(100);
    } else {
      $('.back-to-top').fadeOut(100);
    }

    if (window.scrollY + window.innerHeight >= ($(document).height() - 20)) {
      $('.go-to-bottom').fadeOut(100);
    }
    else if (window.scrollY > 0) {
      $('.go-to-bottom').fadeIn(100);
    }
  }

  backToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  goToBottom() {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  }

}
